import type { ClientOption } from '@/types/api/queries';

import { AsyncAutoComplete } from '@/components';

import {
  clientOptionLabel,
  clientOptionValue,
  transformClientsResponse,
} from '@/helpers';

type ClientAutoCompleteProps = {
  fetchUrl: string;
  queryKey: string[];
  label: string;
  value: ClientOption | null;
  onChange: (client: ClientOption | null) => void;
};

export const ClientAutoComplete = (props: ClientAutoCompleteProps) => {
  const { fetchUrl, queryKey, label, value, onChange } = props;

  return (
    <AsyncAutoComplete<ClientOption, unknown>
      fetchUrl={fetchUrl}
      queryKey={queryKey}
      label={label}
      selectedValue={value}
      onSelectedValueChange={onChange}
      transformResponse={transformClientsResponse}
      getOptionLabel={clientOptionLabel}
      getOptionValue={clientOptionValue}
    />
  );
};
